var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group row pb-4" }, [
          _c(
            "label",
            {
              staticClass: "col-lg-3 text-lg-end pt-2",
              attrs: { for: "input-no-kartu" },
            },
            [_vm._v("No. Kartu BPJS")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.no_bpjs,
                  expression: "form.no_bpjs",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "input-no-kartu", readonly: "" },
              domProps: { value: _vm.form.no_bpjs },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "no_bpjs", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validation.dokter_poli
              ? _c(
                  "small",
                  {
                    staticClass: "form-text text-danger",
                    attrs: {
                      tabindex: "-1",
                      id: "input-group-1__BV_description_",
                    },
                  },
                  [_vm._v("Dokter poli harus diisi!")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group row pb-4" }, [
          _c(
            "label",
            {
              staticClass: "col-lg-3 text-lg-end pt-2",
              attrs: { for: "input-no-rm" },
            },
            [_vm._v("Nomor RM")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.nomor_rm,
                  expression: "form.nomor_rm",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "input-no-rm", readonly: "" },
              domProps: { value: _vm.form.nomor_rm },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "nomor_rm", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validation.nomor_rm
              ? _c(
                  "small",
                  {
                    staticClass: "form-text text-danger",
                    attrs: {
                      tabindex: "-1",
                      id: "input-group-1__BV_description_",
                    },
                  },
                  [_vm._v("Nomor RM harus diisi!")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group row pb-4" }, [
          _c(
            "label",
            {
              staticClass: "col-lg-3 text-lg-end pt-2",
              attrs: { for: "input-nama-pasien" },
            },
            [_vm._v("Nama Pasien")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.nama_pasien,
                  expression: "form.nama_pasien",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "input-nama-pasien" },
              domProps: { value: _vm.form.nama_pasien },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "nama_pasien", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validation.nama_pasien
              ? _c(
                  "small",
                  {
                    staticClass: "form-text text-danger",
                    attrs: {
                      tabindex: "-1",
                      id: "input-group-1__BV_description_",
                    },
                  },
                  [_vm._v("Nama pasien harus diisi!")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.error
        ? _c("div", { staticClass: "col-lg-5" }, [
            _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "select-kategori-pasien" },
                },
                [_vm._v("Kategori Pasien")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c("b-form-select", {
                    staticClass: "form-select",
                    attrs: {
                      id: "select-kategori-pasien",
                      options: _vm.option_kategori_pasien,
                    },
                    on: { change: _vm.setKategori },
                    model: {
                      value: _vm.form.kategori_pasien,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "kategori_pasien", $$v)
                      },
                      expression: "form.kategori_pasien",
                    },
                  }),
                  _vm._v(" "),
                  _vm.validation.kategori_pasien
                    ? _c(
                        "small",
                        {
                          staticClass: "form-text text-danger",
                          attrs: {
                            tabindex: "-1",
                            id: "input-group-1__BV_description_",
                          },
                        },
                        [_vm._v("Kategori pasien harus diisi!")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [_vm._v(_vm._s(_vm.error_message))]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _vm.form.kategori_pasien != "null"
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "input-tgl-berobat" },
                },
                [_vm._v("Tanggal Berobat")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tgl_berobat,
                      expression: "form.tgl_berobat",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "date", id: "input-tgl-berobat" },
                  domProps: { value: _vm.form.tgl_berobat },
                  on: {
                    change: _vm.getPoli,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "tgl_berobat", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.validation.tgl_berobat
                  ? _c(
                      "small",
                      {
                        staticClass: "form-text text-danger",
                        attrs: {
                          tabindex: "-1",
                          id: "input-group-1__BV_description_",
                        },
                      },
                      [_vm._v("Tanggal berobat harus diisi!")]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _vm.form.tgl_berobat && _vm.kategori == 2
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "input-no-rujukan" },
                },
                [_vm._v("No. Rujukan / No. Surat Kontrol")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  !_vm.manual_rujukan
                    ? _c("b-form-select", {
                        staticClass: "form-select",
                        attrs: {
                          id: "select-kategori-pasien",
                          options: _vm.option_no_rujukan,
                        },
                        on: { change: _vm.cekRujukan },
                        model: {
                          value: _vm.form.no_rujukan,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "no_rujukan", $$v)
                          },
                          expression: "form.no_rujukan",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.manual_rujukan
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.no_rujukan,
                            expression: "form.no_rujukan",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "input-no-rujukan",
                          placeholder:
                            "Masukkan No. Rujukan / No. Surat Kontrol",
                        },
                        domProps: { value: _vm.form.no_rujukan },
                        on: {
                          change: _vm.cekRujukan,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "no_rujukan",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.validation.no_rujukan
                    ? _c(
                        "small",
                        {
                          staticClass: "form-text text-danger",
                          attrs: {
                            tabindex: "-1",
                            id: "input-group-1__BV_description_",
                          },
                        },
                        [_vm._v("Rujukan harus diisi!")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        (_vm.form.tgl_berobat && _vm.kategori != 2) ||
        _vm.form.no_rujukan != "null"
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "select-poli" },
                },
                [_vm._v("Poliklinik Tujuan")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c("b-form-select", {
                    staticClass: "form-select",
                    attrs: { id: "select-poli", options: _vm.option_poli },
                    on: { change: _vm.getDokter },
                    model: {
                      value: _vm.form.poli_tujuan,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "poli_tujuan", $$v)
                      },
                      expression: "form.poli_tujuan",
                    },
                  }),
                  _vm._v(" "),
                  _vm.validation.poli_tujuan
                    ? _c(
                        "small",
                        {
                          staticClass: "form-text text-danger",
                          attrs: {
                            tabindex: "-1",
                            id: "input-group-1__BV_description_",
                          },
                        },
                        [_vm._v("Poli tujuan harus diisi!")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _vm.form.poli_tujuan != "null"
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "select-dokter" },
                },
                [_vm._v("Dokter Poli")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c("b-form-select", {
                    staticClass: "form-select",
                    attrs: { id: "select-dokter", options: _vm.option_dokter },
                    on: { change: _vm.checkKuota },
                    model: {
                      value: _vm.form.dokter_poli,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dokter_poli", $$v)
                      },
                      expression: "form.dokter_poli",
                    },
                  }),
                  _vm._v(" "),
                  _vm.validation.dokter_poli
                    ? _c(
                        "small",
                        {
                          staticClass: "form-text text-danger",
                          attrs: {
                            tabindex: "-1",
                            id: "input-group-1__BV_description_",
                          },
                        },
                        [_vm._v("Dokter poli harus diisi!")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _vm.form.dokter_poli != "null"
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c(
                "label",
                {
                  staticClass: "col-lg-3 text-lg-end pt-2",
                  attrs: { for: "input-no-hp" },
                },
                [_vm._v("No. Telepon/HP")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.no_hp,
                      expression: "form.no_hp",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "input-no-hp" },
                  domProps: { value: _vm.form.no_hp },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "no_hp", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.validation.no_hp
                  ? _c(
                      "small",
                      {
                        staticClass: "form-text text-danger",
                        attrs: {
                          tabindex: "-1",
                          id: "input-group-1__BV_description_",
                        },
                      },
                      [_vm._v("No. HP harus diisi!")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "small",
                  {
                    staticClass: "form-text text-danger",
                    attrs: {
                      tabindex: "-1",
                      id: "input-group-1__BV_description_",
                    },
                  },
                  [_vm._v("(* Nomor yang bisa dihubungi)")]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _vm.form.no_hp && _vm.form.dokter_poli != "null"
          ? _c("div", { staticClass: "form-group row pb-4" }, [
              _c("label", {
                staticClass: "col-lg-3 text-lg-end pt-2",
                attrs: { for: "input-alamat-email" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "col-lg-4",
                      attrs: { variant: "success" },
                      on: { click: _vm.goRegister },
                    },
                    [_vm._v("Daftar")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }